import * as yup from "yup";
import { isOibValid } from "ui/components/TextField/OibTextField/validation";

export const IGNORE_ERROR = "IGNORE";

export const CONTACT_EDIT_FORM_SCHEMA = yup.object().shape({
  contactTypeId: yup
    .string()
    .required('Molimo Vas da odaberete tip kontakta'),
  companyName: yup
    .string()
    .nullable()
    .when("contactTypeId", {
      is: (val: string) => val === "C",
      then: (schema) => schema.required("Molimo Vas da unesete naziv tvrtke"),
      otherwise: (schema) => schema.notRequired(),
    }),
  firstName: yup
    .string()
    .nullable()
    .when("contactTypeId", {
      is: (val: string) => val === "P",
      then: (schema) => schema.required("Molimo Vas da unesete ime"),
      otherwise: (schema) => schema.notRequired(),
    }),
  lastName: yup
    .string()
    .nullable()
    .when("contactTypeId", {
      is: (val: string) => val === "P",
      then: (schema) => schema.required("Molimo Vas da unesete prezime"),
      otherwise: (schema) => schema.notRequired(),
    }),
  personalIdentificationNumber: yup
    .string()
    .nullable()
    .when("contactTypeId", {
      is: (val: string) => val === "C",
      then: (schema) => schema.required("Molimo Vas da unesete OIB"),
      otherwise: (schema) => schema.notRequired(),
    })
    .test("oib-valid", "Neispravan OIB", (value) => {
      if (!value) return true;
      return isOibValid(value);
    })
});
